import React, { useState, useEffect } from 'react';
import { Form, InputNumber, Button, Modal, Select } from 'antd';
import apiService from '../api/apiService';
import { toast } from 'react-toastify';

function EditInventoryModal({
  isOpen,
  onClose,
  onSave,
  existingData,
  hotelId,
}) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);

  // Fetch inventory items
  useEffect(() => {
    const fetchInventoryItems = async () => {
      setLoadingItems(true);
      try {
        const response = await apiService.get(`/inventory/?hotel=${hotelId}`);
        console.log(response);
        setInventoryItems(response);
      } catch (error) {
        console.error('Failed to fetch inventory items:', error);
        toast.error('Failed to load inventory items.');
      } finally {
        setLoadingItems(false);
      }
    };

    if (isOpen) {
      fetchInventoryItems();
    }
  }, [hotelId, isOpen]);

  // Set form fields
  useEffect(() => {
    if (existingData) {
      form.setFieldsValue({
        itemName: existingData.id || '', // Set to inventory id
        quantity: existingData.quantity || 0,
      });
    } else {
      form.resetFields();
    }
  }, [existingData, form]);

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const handleEdit = async values => {
    const updatedInventory = {
      inventory: values.itemName, // Now the inventory id
      quantity: values.quantity,
      hotel: Number(hotelId),
    };

    try {
      if (existingData) {
        const response = await apiService.post(
          `/inventory-updates/?hotel=${hotelId}`,
          updatedInventory
        );
        toast.success('Inventory updated successfully!');
        onSave(response);
        handleCancel();
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to save the inventory.');
    }
  };

  if (!isOpen) return null;

  return (
    <Modal
      centered
      title={existingData ? 'Edit Inventory' : 'Add Inventory'}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleEdit}>
        <Form.Item
          label="Item Name"
          name="itemName"
          rules={[{ required: true, message: 'Please select the item name' }]}
        >
          <Select
            placeholder="Select item"
            loading={loadingItems}
            showSearch
            optionFilterProp="children"
          >
            {inventoryItems.map(item => (
              <Option key={item.id} value={item.id}>
                {item.item_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Quantity"
          name="quantity"
          rules={[{ required: true, message: 'Please enter the quantity' }]}
        >
          <InputNumber
            min={0}
            step={1}
            style={{ width: '100%' }}
            placeholder="Enter quantity"
          />
        </Form.Item>

        <div className="form-actions d-flex justify-content-end">
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default EditInventoryModal;
